function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}
//CARGA EL POP-UP DE LA PAGINA PRINCIPAL

document.addEventListener('DOMContentLoaded', function () {
  // Comprueba si ya se mostró el pop-up
  const popupShown = document.cookie.split('; ').find(row => row.startsWith('popup_shown='));

  // Mostrar el pop-up solo si no se ha mostrado antes
  if (!popupShown && window.location.pathname === '/') {
    setTimeout(function () {
      document.getElementById('custom-popup').style.display = 'flex';
      
    // Cambia el tiempo de espera si lo deseas
    }, 500); 

    // Establecer una cookie para no volver a mostrar el pop-up
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 7); // Cookie válida por X días
    document.cookie = `popup_shown=true; path=/; expires=${expiryDate.toUTCString()}`;
  }

  // Función para cerrar el pop-up
  document.getElementById('close-popup').addEventListener('click', function () {
    document.getElementById('custom-popup').style.display = 'none';
  });
});

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  document.querySelectorAll(`[data-section="${event.detail.sectionId}"]`).forEach((element) => {
    element.remove();
    document.body.classList.remove('overflow-hidden');
  });
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());
